export const currentVersion = "Alpha 1.03";

export const changelog = [
    {
        version: "Alpha 1.03",
        date: "2026-01-14",
        features: [
            "Persistent Print Sets: Save and load entire custom print layouts (Wristband cards & Single pages)",
            "Cloud Synchronization: Print sets now sync to Firebase Firestore within cloud playbooks for collaborative coaching",
            "WYSIWYG Print Manager Enhancements: Refined scaling, positioning, and annotation persistence",
            "Collaborative Metadata: See who last updated a print layout in cloud playbooks"
        ],
        fixes: [
            "Improved JSX stability in Print Manager Left Rail",
            "Fixed scaling issues when transitioning between local and cloud print states"
        ]
    },
    {
        version: "Alpha 1.02",
        date: "2025-12-24",
        features: [
            "Modularized formations data (moved to src/data/formations.js)",
            "Cleaned up Git repository issues and ignored node_modules",
            "Removed duplicate legacy project folders"
        ],
        fixes: [
            "Improved code organization and build stability"
        ]
    },
    {
        version: "Alpha 1.01",
        date: "2025-12-23",
        features: [
            "Incremental update"
        ],
        fixes: []
    },
    {
        version: "Alpha 1.00",
        date: "2025-12-15",
        features: [
            "Added Version Number and Changelog view",
            "Centered Play Name in Header",
            "Split Quick Formations into Offense and Defense",
            "Added Global Player Icon Size Setting",
            "Added Player Shape Selection (Circle, Square, Triangle, X)",
            "Restored Player Property features (Line Ends, Zones, etc.)",
            "Added Speed (40-yard dash) slider"
        ],
        fixes: [
            "Improved header layout stability"
        ]
    }
];
